<template>
  <div class="memberEvent">
    <div class="btn2">
      <el-radio-group v-model="tabPosition" style="margin-bottom: 30px">
        <el-radio-button label="1">基础透视</el-radio-button>
        <el-radio-button label="2">业务透视</el-radio-button>
      </el-radio-group>
    </div>
    <el-card shadow="never" class="my-card">
      <ul class="ul1">
        <!-- 第一行 -->
        <li class="user">
          <h3 style="font-weight:500;">用户属性透视</h3>
          <ul>
            <li @click="$router.push({ name: 'memberEvent_details' })">
              <img
                src="../../assets/images/ticons/vipevent_active_icon@2x.png"
                alt=""
              />
              <p>活跃度透视</p>
            </li>
            <li>
              <img
                src="../../assets/images/ticons/vipevent_loss_icon@2x.png"
                alt=""
              />
              <p>流失透视</p>
            </li>
            <li>
              <img
                src="../../assets/images/ticons/vipevent_monomer_icon@2x.png"
                alt=""
              />
              <p>单体价值透视</p>
            </li>
            <li>
              <img
                src="../../assets/images/ticons/vipevent_group_icon@2x.png"
                alt=""
              />
              <p>群体价值透视</p>
            </li>
            <li>
              <img
                src="../../assets/images/ticons/vipevent_gender_icon@2x.png"
                alt=""
              />
              <p>性别透视</p>
            </li>
            <li>
              <img
                src="../../assets/images/ticons/vipevent_regional_icon@2x.png"
                alt=""
              />
              <p>地域透视</p>
            </li>
          </ul>
        </li>
        <!-- 第二行 -->
        <li class="user">
          <h3 style="font-weight:500;">行为体系透视</h3>
          <ul>
            <li>
              <img
                src="../../assets/images/ticons/vipevent_access_icon@2x.png"
                alt=""
              />
              <p>访问流失分层</p>
            </li>
            <li>
              <img
                src="../../assets/images/ticons/vipevent_pay_icon@2x.png"
                alt=""
              />
              <p>支付流失分层</p>
            </li>
            <li>
              <img
                src="../../assets/images/ticons/vipevent_expense_icon@2x.png"
                alt=""
              />
              <p>消费金额分层</p>
            </li>
            <li>
              <img
                src="../../assets/images/ticons/vipevent_indent_icon@2x.png"
                alt=""
              />
              <p>订单取消透视</p>
            </li>
            <li>
              <img
                src="../../assets/images/ticons/vipevent_useshare_icon@2x.png"
                alt=""
              />
              <p>用户分享透视</p>
            </li>
            <li>
              <img
                src="../../assets/images/ticons/vipevent_share_icon@2x.png"
                alt=""
              />
              <p>分享结果透视</p>
            </li>
          </ul>
        </li>
        <!-- 第三行 -->
        <li class="user">
          <h3 style="font-weight:500;">营销体系透视</h3>
          <ul>
            <li>
              <img
                src="../../assets/images/ticons/vipevent_sensitive_icon@2x.png"
                alt=""
              />
              <p>优惠券敏感度</p>
            </li>
            <li>
              <img
                src="../../assets/images/ticons/vipevent_repurchase_icon@2x.png"
                alt=""
              />
              <p>用户复购透视</p>
            </li>
            <li>
              <img
                src="../../assets/images/ticons/vipevent_preference_icon@2x.png"
                alt=""
              />
              <p>优惠券偏好透视</p>
            </li>
            <li>
              <img
                src="../../assets/images/ticons/vipevent_type_icon@2x.png"
                alt=""
              />
              <p>优惠券类型透视</p>
            </li>
          </ul>
        </li>
      </ul>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabPosition: "1",
    };
  },
};
</script>
<style lang="less">
.memberEvent {
  padding: 20px;
  .btn2 {
    margin-top: 10px;
    .el-radio-button:first-child .el-radio-button__inner {
      border-radius: 18px 0 0 18px;
    }
    .el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0 18px 18px 0;
    }
  }
  .my-card {
    height: 800px;
    .ul1 {
      > li {
        &:nth-child(2) {
          margin-top: 100px;
        }
        &:nth-child(3) {
          margin-top: 100px;
        }
      }
      .user {
        h3 {
          font-size: 16px;
          margin-bottom: 40px;
        }
        ul {
          display: flex;
          li {
            margin-left: 72px;
            &:first-child {
              margin-left: 0;
            }
            img {
              width: 86px;
            }
            p {
              margin-top: 10px;
              text-align: center;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>